import spinRoute from '../../router/spinRoute.js';

export default () => [
    {
        path: '/flow/initiateIns',
        component: () => spinRoute.require(import('./instance/initiateIns.vue')),
        meta: { title: kygMsg(900482, '发起申请'), hideBarFoot: true },
    },
    {
        path: '/flow/approveIns',
        component: () => spinRoute.require(import('./instance/approveIns.vue')),
        meta: { title: '审批流程', hideBarFoot: true },
    },
    {
        path: '/flow/viewIns',
        component: () => spinRoute.require(import('./instance/viewIns.vue')),
        meta: { title: '查看流程', hideBarFoot: true },
    },
    {
        path: '/flow/draftIns',
        component: () => spinRoute.require(import('./instance/draftIns.vue')),
        meta: { title: '流程草稿', hideBarFoot: true },
    },
]
